import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CrossIcon } from '../verticalDropdown/svgData';
import CharFadeText from '../Animation/CharFadeText';
import { useNavigate } from 'react-router-dom';

const RarityOfficialCard = ({ openModal, handleOrder,images, sliderImages, isGia }) => {

    const [showDialog, setShowDialog] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const navigate = useNavigate();

    const handleSlideChange = (swiper) => {
        setActiveIndex(swiper.realIndex);
    };

    const getThumbnailImages = () => {
        return sliderImages.filter((_, index) => index !== activeIndex);
    };

    const handleCloseDialog = () => {
        setShowDialog(false);
    };

    const handleCreateNewReport = () => {
    navigate("/", {
      state: {
        tab: "tab1",
        showGia: true,
      },
    });
  };
    return (
        <>
            <div className="rarity-update-container">
                <div className="rarity-update-right-content">
                    <h2>Own the official Report</h2>
                </div>
                <div className="slider-container">
                    <Swiper
                        modules={[Autoplay, Pagination, Navigation]}
                        spaceBetween={30}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        onSlideChange={handleSlideChange}
                        pagination={{ clickable: true }}
                    >
                        {showDialog && (
                            <div className="slider-dialog-overlay">

                                <div className="slider-dialog-box">
                                    <div className="cross-icon" onClick={handleCloseDialog}>
                                        <CrossIcon />
                                    </div>
                                    {/* <h3 className="text-dark">Be Ready Before the Launch</h3> */}
                                    <p>
                                        The official launch is on September 10th. Order your printed Rarity Report today to ensure early access.
                                    </p>
                                    <button className=" no-outline-btn  btn btn-primary px-4 slider-dialog-btn" onClick={handleCloseDialog}>Got it</button>
                                </div>
                            </div>
                        )}
                        {images.map((imgSrc, index) => (
                            <SwiperSlide key={index}>
                                <img
                                    src={imgSrc}
                                    alt={`Slide ${index + 1}`}
                                    className="slider-image"
                                    onClick={() => openModal(index)}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="slider-thumb-img">
                    <div className="slider-grid">
                        {getThumbnailImages().map((item) => (
                            <div className="slider-grid-img">
                                <img
                                    src={item}
                                    alt={`Slide`}
                                    className="slider-image"
                                    onClick={() => openModal(images.indexOf(item))}
                                /></div>
                        ))}

                    </div>
                </div>
                {isGia ? <Button className="processBtn rarity-order-btn" onClick={handleOrder} ><CharFadeText text = "Order Official Copy" /></Button> :<div className='rarity-print-new'>
                    <p>Currently, printed reports can be issued only for diamonds with GIA numbers only</p>
<Button className="processBtn rarity-order-btn" onClick={handleCreateNewReport} ><CharFadeText text = "Create New Report" /></Button>
                </div> }
                        
            </div>
        </>
    )
}

export default RarityOfficialCard